import React from 'react';

interface NoteUnreadBadgeProps {
  count: number;
}

const NoteUnreadBadge: React.FC<NoteUnreadBadgeProps> = ({ count }) => {
  return (
    <span
      style={{
        display: 'flex',
        width: 16,
        height: 15,
        padding: 4,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
        borderRadius: 16,
        background: 'var(--brand-colours-indigo-indigo-400, #7046AE)',
        marginLeft: 8,
      }}
    >
      <span
        style={{
          color: '#FFF',
          textAlign: 'center',
          fontFamily: 'var(--typography-font-family-base, Manrope)',
          fontSize: 'var(--typography-font-size-overline, 11px)',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '140%',
          letterSpacing: 0.242,
          textTransform: 'uppercase',
        }}
      >
        {count}
      </span>
    </span>
  );
};

export default NoteUnreadBadge;
